<template>
    <g-modal
            v-model="modal"
            :closable="false"
            :width="null"
            wrapClassName="global-exit-modal"
            :maskStyle="{backgroundColor: 'rgba(255, 255, 255, 0.5)'}"
    >
        <div class="margin-bottom-small">
            <g-typography tag="h3" fontWeight="semibold" font-weith value="Are you Sure?"/>
        </div>
        <g-typography tag="p" value="This will take you back to an overview of the steps. Any changes made to this step will not be saved. "/>
        <template slot="footer">
            <div class="modal-footer">
                <g-button @click="handleCancel">Cancel</g-button>
                <g-button @click="handleExit" type="danger" theme="live">Exit</g-button>
            </div>
        </template>
    </g-modal>
</template>

<script>
    export default {
        name: "GlobalExitModal",
        props: {
            visible: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                modal: false,
            };
        },
        methods: {
            handleExit() {
                this.$emit('global-modal-exit');
            },
            handleCancel() {
                this.$emit('global-modal-cancel');
            },
        },
        watch: {
            visible(val) {
                this.modal = val;
            },
        },
    }
</script>

<style lang="scss" scoped>
    .modal-footer {
        display: flex;
        justify-content: flex-end;
        padding: $g-spacing-7;
    }
    .margin-bottom-small {
        margin-bottom: $g-spacing-3;
    }
</style>

<style lang="scss">
    .global-exit-modal .ant-modal {
        width: $g-screen-size-xs;
        padding: $g-spacing-5;
    }
    .global-exit-modal .ant-modal-body {
        padding: $g-spacing-7;
    }
    .global-exit-modal .ant-modal-footer {
        border: none;
        padding: 0;
    }
</style>
